import MenuComponent from "./core/MenuComponent";
import RowComponent from "./core/RowComponent";
import CellComponent from "./core/CellComponent";
import Dispatcher from "./core/Dispatcher";
import FunctionComponent from "./core/FunctionComponent";

import EmptyComponent from "./base/EmptyComponent";
import InputComponent from "./base/InputComponent";
import LabelComponent from "./base/LabelComponent";
import ButtonComponent from "./base/ButtonComponent";
import PageComponent from "./base/PageComponent";
import SelectComponent from "./base/SelectComponent";
import RadioComponent from "./base/RadioComponent";
import CheckboxComponent from "./base/CheckboxComponent";
import CheckboxGroupComponent from "./base/CheckboxGroupComponent";
import DateComponent from "./base/DateComponent";
import IconComponent from "./base/IconComponent";
import StepComponent from "./base/StepComponent";
import AlertComponent from "./base/AlertComponent";
import DividerComponent from "./base/DividerComponent";
import NumberComponent from "./base/NumberComponent";
import TabComponent from "./base/TabComponent";
import TransferComponent from "./base/TransferComponent";
import ImageComponent from "./base/ImageComponent";
import SliderComponent from "./base/SliderComponent";
import CascaderComponent from "./base/CascaderComponent";
import DateLabelComponent from "./base/DateLabelComponent";
import CalendarComponent from "./base/CalendarComponent";

import FormComponent from "./pack/FormComponent";
import TableComponent from "./pack/TableComponent";
import CardCellComponent from "./pack/CardCellComponent";
import GridComponent from "./pack/GridComponent";
import UploadComponent from "./pack/UploadComponent";
import TagGroupComponent from "./pack/TagGroupComponent";
import ListComponent from "./pack/ListComponent";

import LineChartComponent from "./chart/LineChartComponent";
import HistogramChartComponent from "./chart/HistogramChartComponent";
import BarChartComponent from "./chart/BarChartComponent";
import PieChartComponent from "./chart/PieChartComponent";
import RingChartComponent from "./chart/RingChartComponent";
import WaterfallChartComponent from "./chart/WaterfallChartComponent";
import FunnelChartComponent from "./chart/FunnelChartComponent";
import RadarChartComponent from "./chart/RadarChartComponent";
import MapChartComponent from "./chart/MapChartComponent";
import SankeyChartComponent from "./chart/SankeyChartComponent";
import HeatmapChartComponent from "./chart/HeatmapChartComponent";
import ScatterChartComponent from "./chart/ScatterChartComponent";
import CandleChartComponent from "./chart/CandleChartComponent";
import GaugeChartComponent from "./chart/GaugeChartComponent";
import TreeChartComponent from "./chart/TreeChartComponent";
import LiquidFillChartComponent from "./chart/LiquidFillChartComponent";
import WordCloudChartComponent from "./chart/WordCloudChartComponent";

import PageTitleComponent from "./spec/PageTitleComponent";
import BPMNComponent from "./spec/BPMNComponent";
import OrgTreeComponent from "./spec/OrgTreeComponent";
import RoleMaintenance from "./../views/OrganizationMaintenance/RoleMaintenance"; //角色权限维护-列表
import RoleMessEdit from "./../views/OrganizationMaintenance/RoleMessEdit"; //角色权限维护-编辑
import ApprovalProcessSetList from "./process/SystemSettings/ApprovalProcessSetList"; // 审批流程设定
import ApprovalProcessSet from "./process/SystemSettings/ApprovalProcessSet"; // 审批流程设定
import PersonalFiles from "./process/MyQuery/PersonalFiles"; //个人档案
import EmployeeFiles from "./process/MyQuery/EmployeeFiles"; //员工档案
import OnboardingTask from "./process/MyQuery/OnboardingTask"; //入职Task报表

import PersonalFilesSetting from "./process/SystemSettings/PersonalFilesSetting"; // 个人档案设定
import EmployeeFilesSetting from "./process/SystemSettings/EmployeeFilesSetting"; // 员工档案设定

import NormalDistributionReport from "./bipage/NormalDistributionReport.vue";
import CompetencyAssessment from "./bipage/CompetencyAssessment.vue";

import HomePage from "./index/HomePage.vue"; //首页
import QuestionAndAnswers from "./index/QuestionAndAnswers"; //问答详情
import InternationalViewSet from "./process/SystemSettings/InternationalViewSet"; // 国际化设定
import fileInternationalViewSet from "./process/SystemSettings/fileInternationalViewSet"; // 员工档案列表配置设定
import MainImageSave from "./process/SystemSettings/MainImageSave"; // 主页画面维护
//申请单
import ApplyListNew from "./process/Apply/components/ApplyListNew"; //申请一览
import AgencyApply from "./process/Apply/components/AgencyApply"; //代理申请一览
import ContractRenewApply from "./process/Apply/ContractRenewApply"; //合同续签申请
import ContractRenewApproval from "./process/Apply/ContractRenewApproval"; //合同续签审批
import ProbationApply from "./process/Apply/ProbationApply"; //试用期评估申请
import ProbationApproval from "./process/Apply/ProbationApproval"; //试用期评估审批
import OnboardingApply from "./process/Apply/OnboardingApply"; //入职申请
import OnboardingApproval from "./process/Apply/OnboardingApproval"; //入职审批

import ExitApply from "./process/Apply/ExitApply"; //离职申请
import ExitApproval from "./process/Apply/ExitApproval"; //离职申请

import OverTimeApply from "./process/Apply/OverTimeApply"; //加班申请
import OverTimeApproval from "./process/Apply/OverTimeApproval"; //加班审批
import LeaveApplicationApply from "./process/Apply/LeaveApplicationApply"; //休假申请
import LeaveApplicationApproval from "./process/Apply/LeaveApplicationApproval"; //休假审批
import TransferApply from "./process/Apply/TransferApply"; //员工转岗申请
import TransferApproval from "./process/Apply/TransferApproval"; //员工转岗审批
import OvertimeModificationApply from "./process/Apply/OvertimeModificationApply"; //加班修改申请
import OvertimeModificationApproval from "./process/Apply/OvertimeModificationApproval"; //加班修改审批
import cardApply from "./process/Apply/cardApply"; //刷卡记录申请
import cardApproval from "./process/Apply/cardApproval"; //刷卡记录申请
import ApplyAchStartYear from "./process/Apply/ApplyAchStartYear"; //绩效年初申请
import ApplyHistoryAchStartYear from "./process/Apply/ApplyHistoryAchStartYear"; //绩效年初申请历史
import ApprovalAchStartYear from "./process/Apply/ApprovalAchStartYear"; //绩效年初审批
import ApplyAchMidYear from "./process/Apply/ApplyAchMidYear"; //绩效年中申请
import ApprovalAchMidYear from "./process/Apply/ApprovalAchMidYear"; //绩效年中审批
import ApplyAchEndYear from "./process/Apply/ApplyAchEndYear"; //绩效年底申请
import ApprovalAchEndYear from "./process/Apply/ApprovalAchEndYear"; //绩效年底审批

import ApplyAfterPage from "./process/Component/applyAfterPage"; // 申请成功页面
import ApprovalAfterPage from "./process/Component/approvalAfterPage"; // 审批成功页面

// 我的管理
import JobApplicationForm from "./process/MyManagement/JobApplicationForm"; //入职应聘表
import PreEmployment from "./process/MyManagement/PreEmployment"; //预入职一览
import InductionProcess from "./process/MyManagement/InductionProcess"; //入职流程一览
import OnBoardingQRCode from "./process/MyManagement/OnBoardingQRCode"; //入职流程一览

// 绩效管理
import IndexLibrary from "./process/performanceManagement/IndexLibrary"; // 指标库一览
import PerformanceType from "./process/performanceManagement/PerformanceType"; // 绩效类型设定型
import PerformanceStatus from "./process/performanceManagement/PerformanceStatus"; // 绩效状态设定
import PerformanceIndicator from "./process/performanceManagement/PerformanceIndicator"; // 绩效指标设定
import performanceAndScoreRule from "./process/performanceManagement/performanceAndScoreRule"; // 绩效模板及评分规则设定
import QualitativeEvaluationAnd360 from "./process/performanceManagement/QualitativeEvaluationAnd360"; // 绩效模板及评分规则设定
import AchFormulaSet from "./process/performanceManagement/AchFormulaSet"; // 绩效模板及评分规则设定
import AchAssess from "./process/performanceManagement/AchAssess"; // 绩效模板及评分规则设定
import PerformanceReport from "./process/performanceManagement/PerformanceReport"; // 绩效报表
import PotentialAssessment from "./process/performanceManagement/PotentialAssessment"; // 潜能评估
import AchImprovement from "./process/performanceManagement/AchImprovement"; // 绩效改进
import AchReportHR from "./process/performanceManagement/components/AchReportHR"; // 绩效评估-HR
import MyAchievements from "./process/performanceManagement/MyAchievements"; // 我的绩效
import AchTargetSetting from "./process/performanceManagement/AchTargetSetting"; //  绩效指标设定
import PopleBoard from "./process/performanceManagement/PopleBoard"; //  PopleBoard
import SpecialApply from "./process/performanceManagement/SpecialApply"; //  特殊申请
import AchCorrectApproval from "./process/performanceManagement/AchCorrectApproval"; //  绩效校准审批
import AchApprovalJump from "./process/performanceManagement/AchApprovalJump"; //  批量审批
import SuccessorSummary from "./process/performanceManagement/SuccessorSummary"; //  继任者汇总
import PeoPleBoardJump from "./process/performanceManagement/PeoPleBoardJump"; //  peopleboard跳转页
import PeopleBoardSelectEmpJump from "./process/performanceManagement/PeopleBoardComponents/PeopleBoardSelectEmpJump"; //  peopleboard选人跳转页
import AchApprovalChinaOD from "./process/performanceManagement/components/PerformanceEvaluationChinaOD"; // 绩效结果 （China OD）
import PositionInventory from "./process/performanceManagement/PositionInventory"; // 关键岗位盘点
import AchApprovalPotential from "./process/performanceManagement/AchApprovalPotential"; //  潜能结果

import FileUP from "@/views/components/FileUP"; //文件上傳
import DraftTemplate from "./process/component/DraftTemplate"; //草稿列表
import DraftPop from "./process/component/DraftPop"; //保存草稿弹窗

import ReminderSetting from "./process/SystemSettings/ReminderSetting"; //提醒设置
import ReminderList from "./process/MyQuery/ReminderList"; //提醒列表
import ReminderDetails from "./process/MyQuery/ReminderDetails"; //提醒列表详情
import MenuSetting from "./index/ContextMenuSetting"; // 快捷菜单入口
import ExitMatter from "./process/MyQuery/ExitMatter"; // 离职事项确认一览
import EPayslip from "./process/MyQuery/EPayslip"; // 薪资单查询
import MyOverTime from "./process/MyQuery/MyOverTime"; // 我的加班
import MyLeave from "./process/MyQuery/MyLeave"; // 我的休假
import MyAttendance from "./process/MyQuery/MyAttendance"; // 我的考勤
import EmployeeOverTime from "./process/MyQuery/EmployeeOverTime"; // 下属加班
import EmoloyeeAttendance from "./process/MyQuery/EmoloyeeAttendance"; // 下属考勤
import EmployeeLeave from "./process/MyQuery/EmployeeLeave"; // 下属休假
import TalentContrast from "./process/MyQuery/TalentContrast"; // 下属休假
import TeamInfo from "./process/MyQuery/TeamInfo"; // 团队信息

import ContinuousCommunication from "./process/MyQuery/ContinuousCommunication"; // 持续沟通

import AnnouncementNoticeSetting from "./process/SystemSettings/AnnouncementNoticeSetting"; // 公告通知设置
import AnnouncementDetails from "./process/SystemSettings/AnnouncementDetails"; // 公告通知详情
import NoticeAnnouncement from "./index/NoticeAnnouncement"; // 公告通知

// Q&A
import QaListInfo from "./process/MyQuery/QaListInfo"; // 我的问答
import QaMasterSet from "./process/SystemSettings/QaMasterSet"; // 问答设置

import TrainManageInfo from "./index/TrainManageInfo";

import LvCtrlSet from "./process/SystemSettings/LvCtrlSet"; // 休假政策设定
import OtCtrlSet from "./process/SystemSettings/OtCtrlSet"; // 加班政策设定
import LvDaysMaster from "./process/SystemSettings/LvDaysMaster"; // 休假最大时长设定
import RolePermissionsMain from "./process/SystemSettings/RolePermissionsMain/RolePermissionsMain"; //  角色权限维护
import PermissionMaintenance from "./process/SystemSettings/PermissionMaintenance"; // 权限维护
import ApprovalProcess from "./process/SystemSettings/ApprovalProcess"; // 审批流程设定
import AgentAsUserSet from "./process/SystemSettings/AgentAsUserSet"; // 代理审批权限维护

import MenuPageInfo from "./site/MenuPageInfo"; //菜单维护
import OrgPosition from "./site/OrgPosition"; //菜单维护

import MyLvSurPlus from "./process/MyQuery/MyLvSurPlus"; //我的假期结余
import EmployeeLvSurPlus from "./process/MyQuery/EmployeeLvSurPlus"; // 下属假期结余
import EmployeeEpayLip from "./process/MyQuery/EmployeeEpayLip"; // 下属薪资单
import MyAchGrade from "./process/MyQuery/MyAchGrade"; // 我的绩效等级

import MenuPageData from "./index/MenuPageData"; // 首页

import talentCard from "./process/Component/talentCard"; // TALENT CARD
import HomePageAchUpdate from "./index/components/HomePageAchUpdate"; // 首页绩效改进跳转

import CarlsbergPersonFiles from "./process/files/CarlsbergPersonFiles"; // 个人档案
import CarlsbergEmpTable from "./process/files/CarlsbergEmpTable"; // 员工档案
import CarlsbergEmployeeFiles from "./process/files/CarlsbergEmployeeFiles"; // 员工档案

import CarlsbergFile from "./index/CarlsbergFile"; // 帮助
import CarlsbergFileAdmin from "./index/CarlsbergFileAdmin"; // 帮助



/**
 * J2BPM组件注册
 */
const J2BPMComponent = {
  install(Vue) {

    // 核心组件
    Vue.component("j2-menu", MenuComponent);
    Vue.component("j2-row", RowComponent);
    Vue.component("j2-cell", CellComponent);
    Vue.component("j2-dispatcher", Dispatcher);
    Vue.component("j2-function", FunctionComponent);
    // 基本组件
    Vue.component("j2-empty", EmptyComponent);
    Vue.component("j2-input", InputComponent);
    Vue.component("j2-label", LabelComponent);
    Vue.component("j2-button", ButtonComponent);
    Vue.component("j2-paging", PageComponent);
    Vue.component("j2-select", SelectComponent);
    Vue.component("j2-radio", RadioComponent);
    Vue.component("j2-checkbox", CheckboxComponent);
    Vue.component("j2-checkbox-group", CheckboxGroupComponent);
    Vue.component("j2-date", DateComponent);
    Vue.component("j2-icon", IconComponent);
    Vue.component("j2-step", StepComponent);
    Vue.component("j2-alert", AlertComponent);
    Vue.component("j2-divider", DividerComponent);
    Vue.component("j2-number", NumberComponent);
    Vue.component("j2-tab", TabComponent);
    Vue.component("j2-transfer", TransferComponent);
    Vue.component("j2-image", ImageComponent);
    Vue.component("j2-slider", SliderComponent);
    Vue.component("j2-cascader", CascaderComponent);
    Vue.component("j2-date-label", DateLabelComponent);
    Vue.component("j2-calendar", CalendarComponent);
    // 容器组件
    Vue.component("j2-form", FormComponent);
    Vue.component("j2-table", TableComponent);
    Vue.component("j2-card-cell", CardCellComponent);
    Vue.component("j2-grid", GridComponent);
    Vue.component("j2-upload", UploadComponent);
    Vue.component("j2-tag-group", TagGroupComponent);
    Vue.component("j2-list", ListComponent);
    // 图表组件
    Vue.component("j2-chart-line", LineChartComponent);
    Vue.component("j2-chart-histogram", HistogramChartComponent);
    Vue.component("j2-chart-bar", BarChartComponent);
    Vue.component("j2-chart-pie", PieChartComponent);
    Vue.component("j2-chart-ring", RingChartComponent);
    Vue.component("j2-chart-waterfall", WaterfallChartComponent);
    Vue.component("j2-chart-funnel", FunnelChartComponent);
    Vue.component("j2-chart-radar", RadarChartComponent);
    Vue.component("j2-chart-map", MapChartComponent);
    Vue.component("j2-chart-sankey", SankeyChartComponent);
    Vue.component("j2-chart-heatmap", HeatmapChartComponent);
    Vue.component("j2-chart-scatter", ScatterChartComponent);
    Vue.component("j2-chart-candle", CandleChartComponent);
    Vue.component("j2-chart-gauge", GaugeChartComponent);
    Vue.component("j2-chart-tree", TreeChartComponent);
    Vue.component("j2-chart-liquidfill", LiquidFillChartComponent);
    Vue.component("j2-chart-wordcloud", WordCloudChartComponent);
    // 特殊组件
    Vue.component("j2-page-title", PageTitleComponent);
    Vue.component("j2-bpmn", BPMNComponent);
    Vue.component("j2-org-tree", OrgTreeComponent);

    Vue.component("j2-RoleMaintenance", RoleMaintenance);
    Vue.component("j2-RoleMessEdit", RoleMessEdit);

    Vue.component("j2-ApprovalProcessSetList", ApprovalProcessSetList);
    Vue.component("j2-ApprovalProcessSet", ApprovalProcessSet);
    Vue.component("j2-PersonalFiles", PersonalFiles);
    Vue.component("j2-EmployeeFiles", EmployeeFiles);

    Vue.component("j2-PersonalFilesSetting", PersonalFilesSetting);
    Vue.component("j2-EmployeeFilesSetting", EmployeeFilesSetting);

    Vue.component("j2-NormalDistributionReport", NormalDistributionReport);
    Vue.component("j2-CompetencyAssessment", CompetencyAssessment);

    Vue.component("j2-HomePage", HomePage);
    Vue.component("j2-QuestionAndAnswers", QuestionAndAnswers);
    Vue.component("j2-InternationalViewSet", InternationalViewSet);
    Vue.component("j2-fileInternationalViewSet", fileInternationalViewSet);
    Vue.component("j2-MainImageSave", MainImageSave);

    Vue.component("j2-OnboardingTask", OnboardingTask);

    //申请单
    Vue.component("j2-ApplyListNew", ApplyListNew);
    Vue.component("j2-AgencyApply", AgencyApply);
    Vue.component("j2-ContractRenewApply", ContractRenewApply);
    Vue.component("j2-ContractRenewApproval", ContractRenewApproval);
    Vue.component("j2-ProbationApply", ProbationApply);
    Vue.component("j2-ProbationApproval", ProbationApproval);
    Vue.component("j2-OnboardingApply", OnboardingApply);
    Vue.component("j2-OnboardingApproval", OnboardingApproval);
    Vue.component("j2-ExitApply", ExitApply);
    Vue.component("j2-ExitApproval", ExitApproval);
    Vue.component("j2-OverTimeApply", OverTimeApply);
    Vue.component("j2-OverTimeApproval", OverTimeApproval);
    Vue.component("j2-LeaveApplicationApply", LeaveApplicationApply);
    Vue.component("j2-LeaveApplicationApproval", LeaveApplicationApproval);
    Vue.component("j2-ApplyAfterPage", ApplyAfterPage);
    Vue.component("j2-ApprovalAfterPage", ApprovalAfterPage);
    Vue.component("j2-TransferApply", TransferApply);
    Vue.component("j2-TransferApproval", TransferApproval);
    Vue.component("j2-OvertimeModificationApply", OvertimeModificationApply);
    Vue.component(
      "j2-OvertimeModificationApproval",
      OvertimeModificationApproval
    );
    Vue.component("j2-CardApply", cardApply);
    Vue.component("j2-CardApproval", cardApproval);
    Vue.component("j2-ApplyAchStartYear", ApplyAchStartYear);
    Vue.component("j2-ApplyHistoryAchStartYear", ApplyHistoryAchStartYear);
    Vue.component("j2-ApprovalAchStartYear", ApprovalAchStartYear);
    Vue.component("j2-ApplyAchMidYear", ApplyAchMidYear);
    Vue.component("j2-ApprovalAchMidYear", ApprovalAchMidYear);
    Vue.component("j2-ApplyAchEndYear", ApplyAchEndYear);
    Vue.component("j2-ApprovalAchEndYear", ApprovalAchEndYear);

    // 我的管理
    Vue.component("j2-JobApplicationForm", JobApplicationForm);
    Vue.component("j2-PreEmployment", PreEmployment);
    Vue.component("j2-InductionProcess", InductionProcess);
    Vue.component("j2-OnBoardingQRCode", OnBoardingQRCode);

    //绩效管理
    Vue.component("j2-IndexLibrary", IndexLibrary);
    Vue.component("j2-PerformanceType", PerformanceType);
    Vue.component("j2-PerformanceStatus", PerformanceStatus);
    Vue.component("j2-PerformanceIndicator", PerformanceIndicator);
    Vue.component("j2-performanceAndScoreRule", performanceAndScoreRule);
    Vue.component(
      "j2-QualitativeEvaluationAnd360",
      QualitativeEvaluationAnd360
    );
    Vue.component("j2-AchFormulaSet", AchFormulaSet);
    Vue.component("j2-AchAssess", AchAssess);
    Vue.component("j2-MyAchievements", MyAchievements);
    Vue.component("j2-AchImprovement", AchImprovement);
    Vue.component("j2-AchTargetSetting", AchTargetSetting);
    Vue.component("j2-PopleBoard", PopleBoard);
    Vue.component("j2-SpecialApply", SpecialApply);
    Vue.component("j2-AchCorrectApproval", AchCorrectApproval);
    Vue.component("j2-SuccessorSummary", SuccessorSummary);
    Vue.component("j2-PositionInventory", PositionInventory);
    Vue.component("j2-AchApprovalPotential", AchApprovalPotential);
    //文件上传
    Vue.component("j2-FileUP", FileUP);
    //草稿列表
    Vue.component("j2-DraftTemplate", DraftTemplate);
    Vue.component("j2-DraftPop", DraftPop);

    //提醒
    Vue.component("j2-ReminderSetting", ReminderSetting);
    Vue.component("j2-ReminderList", ReminderList);
    Vue.component("j2-ReminderDetails", ReminderDetails);

    //快捷菜单编辑
    Vue.component("j2-MenuSetting", MenuSetting);

    //公告通知
    Vue.component("j2-AnnouncementNoticeSetting", AnnouncementNoticeSetting);
    Vue.component("j2-AnnouncementDetails", AnnouncementDetails);
    Vue.component("j2-NoticeAnnouncement", NoticeAnnouncement);
    // Q&A
    Vue.component("j2-QaMasterSet", QaMasterSet);
    Vue.component("j2-QaListInfo", QaListInfo);
    Vue.component("j2-LvCtrlSet", LvCtrlSet);
    Vue.component("j2-OtCtrlSet", OtCtrlSet);
    Vue.component("j2-LvDaysMaster", LvDaysMaster);
    Vue.component("j2-PermissionMaintenance", PermissionMaintenance);
    Vue.component("j2-ApprovalProcess", ApprovalProcess);

    // 离职事项确认
    Vue.component("j2-ExitMatter", ExitMatter);
    //薪资单查询
    Vue.component("j2-EPayslip", EPayslip);
    Vue.component("j2-TrainManageInfo", TrainManageInfo);
    Vue.component("j2-MyOverTime", MyOverTime); //加班
    Vue.component("j2-MyLeave", MyLeave); //休假
    Vue.component("j2-MyAttendance", MyAttendance); //我的考勤
    Vue.component("j2-EmployeeOverTime", EmployeeOverTime); //下属加班
    Vue.component("j2-EmoloyeeAttendance", EmoloyeeAttendance); //下属考勤
    Vue.component("j2-EmployeeLeave", EmployeeLeave); //下属休假
    //站点信息
    Vue.component("j2-MenuPageInfo", MenuPageInfo);

    Vue.component("j2-OrgPosition", OrgPosition);
    Vue.component("j2-MyLvSurPlus", MyLvSurPlus);
    Vue.component("j2-EmployeeLvSurPlus", EmployeeLvSurPlus);
    Vue.component("j2-EmployeeEpayLip", EmployeeEpayLip);
    Vue.component("j2-MyAchGrade", MyAchGrade);

    Vue.component("j2-RolePermissionsMain", RolePermissionsMain);

    Vue.component("j2-MenuPageData", MenuPageData);

    Vue.component("j2-PerformanceReport", PerformanceReport);
    Vue.component("j2-PotentialAssessment", PotentialAssessment);
    Vue.component("j2-talentCard", talentCard);
    Vue.component("j2-TalentContrast", TalentContrast);
    Vue.component("j2-TeamInfo", TeamInfo);
    Vue.component("j2-AgentAsUserSet", AgentAsUserSet);
    Vue.component("j2-AchApprovalJump", AchApprovalJump);

    Vue.component("j2-HomePageAchUpdate", HomePageAchUpdate);
    Vue.component("j2-CarlsbergPersonFiles", CarlsbergPersonFiles);
    Vue.component("j2-CarlsbergEmpTable", CarlsbergEmpTable);
    Vue.component("j2-CarlsbergEmployeeFiles", CarlsbergEmployeeFiles);
    Vue.component("j2-PeoPleBoardJump", PeoPleBoardJump);
    Vue.component("j2-PeopleBoardSelectEmpJump", PeopleBoardSelectEmpJump);

    Vue.component("j2-CarlsbergFile", CarlsbergFile);
    Vue.component("j2-CarlsbergFileAdmin", CarlsbergFileAdmin);
    Vue.component("j2-AchReportHR", AchReportHR);
    Vue.component("j2-AchApprovalChinaOD", AchApprovalChinaOD);
    Vue.component("j2-ContinuousCommunication", ContinuousCommunication);

  }
};

export default J2BPMComponent;



// WEBPACK FOOTER //
// ./src/components/J2BPMComponent.js